import { useBootstrapTheme } from "../../contexts/BootstrapThemeContext";
import { EffectThemeContainerProps } from "../../types/effectTheme";



const EffectThemeContainer = ({
    containerClass,
    children,
    style
}:EffectThemeContainerProps) => {
    const { effectiveTheme } = useBootstrapTheme();

    return(
        <div className={`rounded border border-secondary align-items-center ${containerClass ?? ""}`}
                style={{
                ...style,
                background: effectiveTheme === 'dark'
                    ? 'linear-gradient(145deg, rgba(20, 38, 80, 0.95) 0%, rgba(15, 23, 42, 0.98) 50%, rgba(30, 41, 59, 0.95) 100%)'
                    : 'linear-gradient(145deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 0.98) 50%, rgba(241, 245, 249, 0.95) 100%)',
                backdropFilter: 'blur(12px)',
                borderBottom: effectiveTheme === 'dark'
                    ? '1px solid rgba(96, 165, 250, 0.2)'
                    : '1px solid rgba(59, 130, 246, 0.1)',
                boxShadow: effectiveTheme === 'dark'
                    ? '0 8px 32px rgba(59, 130, 246, 0.1), 0 2px 8px rgba(96, 165, 250, 0.05)'
                    : '0 8px 32px rgba(59, 130, 246, 0.08), 0 2px 8px rgba(0, 0, 0, 0.04)'
                }}
            >
            {children}
        </div>
    )
};

export default EffectThemeContainer;